import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { classQuestions, prepTasks } from '../../data/content';
import { STRESSED_INSTRUCTOR_URL } from '../../data/images';

/** Desktop positions for the task tags floating around the photo. */
const tagPositions = ['lg:left-[-14%] lg:top-[8%]', 'lg:right-[-12%] lg:top-[4%]', 'lg:left-[-18%] lg:top-[30%]', 'lg:right-[-16%] lg:top-[26%]', 'lg:left-[-12%] lg:top-[52%]', 'lg:right-[-10%] lg:top-[50%]', 'lg:left-[-6%] lg:top-[76%]', 'lg:right-[-8%] lg:top-[74%]'];
export function ProblemSection() {
  return <section aria-labelledby="problem-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-169" data-mp="33kxexyg6qalh">
      <SectionHeading id="problem-heading" title={<>
            How Much Time Are You Spending Preparing Classes <Accent data-id="element-171" data-mp="1s4qmdjudpl03">You Already Know How to Teach?</Accent>
          </>} body={<>
            You know makeup. But teaching it professionally requires much more than knowing how to create a
            beautiful look.
          </>} data-id="element-170" data-mp="38j8qqeq1iv6c" />

      <div className="mx-auto mt-14 grid max-w-6xl items-center gap-12 lg:grid-cols-[1fr_1fr] lg:gap-24" data-id="element-172" data-mp="1qpdme2ynfzo7">
        <div className="relative mx-auto w-full max-w-[440px]" data-id="element-173" data-mp="24pfyf8k9zyvj">
          <img src={STRESSED_INSTRUCTOR_URL} alt="A makeup instructor overwhelmed at her desk late at night, surrounded by notes, worksheets, a laptop and makeup products" width={928} height={1152} loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-[22px] object-cover shadow-[0_40px_70px_-40px_rgba(34,30,36,0.6)]" data-id="element-174" data-mp="1zpa5zq66m8ce" />
          <ul className="mt-5 flex flex-wrap justify-center gap-2 lg:mt-0" role="list" data-id="element-175" data-mp="2jec4x16op3u1">
            {prepTasks.map((task, index) => <li key={task} className={`rounded-full border border-brand-charcoal/10 bg-white px-3.5 py-1.5 font-body text-[12px] font-medium text-brand-charcoal shadow-[0_8px_20px_-12px_rgba(34,30,36,0.45)] lg:absolute ${tagPositions[index]}`} data-id="element-176" data-mp="2xdbwohphtyuf" data-mpi={index}>
                {task}
              </li>)}
          </ul>
        </div>

        <div data-id="element-177" data-mp="1z0g24wtmvk6z">
          <p className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal" data-id="element-178" data-mp="1yzwty7tsca65">
            Every class means deciding:
          </p>
          <ul className="mt-5 border-t border-brand-charcoal/12" role="list" data-id="element-179" data-mp="28rkfjs3nuwzp">
            {classQuestions.map(question => <li key={question} className="border-b border-brand-charcoal/12 py-3.5 font-display text-[1.3rem] italic leading-snug text-brand-charcoal/85" data-id="element-180" data-mp="2dosxbrkwcz0f">
                “{question}”
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-16 max-w-3xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-181" data-mp="neznz63mpvzm">
        You shouldn't have to rebuild your teaching system <Accent data-id="element-182" data-mp="ku1r5vcsylwh">before every class.</Accent>
      </p>
    </section>;
}